/* tslint:disable */
/* eslint-disable */
/**
 * Ак Барс Недвижимость API
 * Инструменты разработчика:  [ [Документация API. Swagger](/docs/) ]  [ [Документация API. Redoc](/redoc/) ] [ [Панель администрирования](/admin/) ] [ [Документация Image-Service](/api/attachments/docs/) ]
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Bank
 */
export interface Bank {
    /**
     * 
     * @type {number}
     * @memberof Bank
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof Bank
     */
    name: string;
}

export function BankFromJSON(json: any): Bank {
    return BankFromJSONTyped(json, false);
}

export function BankFromJSONTyped(json: any, ignoreDiscriminator: boolean): Bank {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
    };
}

export function BankToJSON(value?: Bank | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
    };
}


